module.exports = __webpack_public_path__ + "img/connah's-quay.068c2604.png";